import type { ReactNode } from "react";
import clsx from "clsx";
import styles from "./FormRow.module.scss";

export interface FormRowProps {
  /** The fields on this line. Each takes an equal share of the width — 1 → 100%, 2 → 50%, 3 → 33%. */
  children: ReactNode;
  className?: string;
}

/**
 * One line of a form card. **Its children always fill the row, split evenly** (STYLE-GUIDE ruling 12).
 *
 * The row is the unit, not the grid: a card used to declare a fixed 2-column grid and pour every field
 * into it, so an odd field count left the last one stranded at half width with dead space beside it
 * (EPK's "Based", 2026‑08‑17). Here the caller states which fields share a line, and the count does the
 * arithmetic — `grid-auto-columns: minmax(0, 1fr)` gives N children N equal columns without anyone
 * naming N, so adding or removing a field cannot leave a hole behind.
 *
 * Below the breakpoint every field takes its own line, because thirds of a phone are not a text input.
 */
export function FormRow({ children, className }: FormRowProps) {
  return <div className={clsx(styles.formRow, className)}>{children}</div>;
}
